import {ActionList, Popover} from '@primer/react'
import {useState} from 'react'

import styles from './AccountSwitchDialog.module.css'
import {isActiveAccount, type StashedAccount, StashedAccountItem} from './AccountSwitcher'
import {ErrorDialog, type ErrorDialogProps} from './ErrorDialog'

export interface AccountSwitchDialogProps {
  ownerLogin: string
  show?: boolean
  stashedAccounts?: StashedAccount[]
  switchAccountPath?: string
}

export function AccountSwitchDialog({show, ownerLogin, stashedAccounts, switchAccountPath}: AccountSwitchDialogProps) {
  const [error, setError] = useState<ErrorDialogProps | false>(false)

  if (!show || !stashedAccounts?.length || !switchAccountPath) {
    return null
  }

  if (error) {
    return <ErrorDialog {...error} onClose={() => setError(false)} />
  }

  return (
    <Popover className={styles.popover} open>
      <Popover.Content className={styles.popoverContent}>
        <ActionList>
          <ActionList.Heading className={styles.dialogHeader} as="h5">
            <span>Signed in as </span> <span className={styles.accountName}>@{ownerLogin}</span>
          </ActionList.Heading>
          <ActionList.Divider className={styles.divider} />
          <ActionList.Group>
            <ActionList.GroupHeading as="h6">Switch to another account</ActionList.GroupHeading>
            {stashedAccounts.map(account =>
              isActiveAccount(account) ? (
                <StashedAccountItem
                  switchAccountPath={switchAccountPath}
                  account={account}
                  setError={setError}
                  key={account.login}
                />
              ) : null,
            )}
          </ActionList.Group>
        </ActionList>
      </Popover.Content>
    </Popover>
  )
}
